module.exports = __webpack_public_path__ + "4663bcee8d1bd5f5f828b8a158eab346.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/antd.png
// module id = 1191
// module chunks = 0